import styled from "styled-components";

export const SSlider = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  height: 100%;
  padding: 0 0.8rem 0 0.8rem;
  border-radius: 99em;

  color: rgb(var(--text-primary-dark-rgb), 0.3);
  border: 0.3rem solid rgba(var(--primary-dark-rgb), 0.3);
  background: rgba(var(--secondary-dark-rgb), 0.4);

  :hover {
    color: rgb(var(--text-primary-dark-rgb), 1);
    border: 0.3rem solid rgba(var(--primary-dark-rgb), 1);
    background: rgba(var(--secondary-dark-rgb), 1);

    .title {
      color: rgb(var(--text-primary-dark-rgb), 1);
    }
  }

  .reaction {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    cursor: pointer;
  }

  .title {
    text-align: center;
    text-transform: uppercase;
    color: rgb(var(--text-primary-dark-rgb), 0.3);
  }

  .description {
    text-transform: uppercase;
  }

  input {
    width: 23vh !important;
  }

  canvas {
    height: 4rem !important;
    width: 4rem !important;
  }
`;
